jQuery(function($) {
    let this_page = 1;
    function setSearchQueryBlog(key, value) {
        let searchParams = new URLSearchParams(window.location.search);
        searchParams.set(key, value);
        let newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
        history.pushState(null, 2, newRelativePathQuery);
    }

    function getParameterByName(name, url = window.location.href) {
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) {
            return null;
        }
        if (!results[2]) {
            return '';
        }
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

    doAjaxQuery(false, true);


//== start loader control ==//
    function loaderControl(action) {
        const wrapper = $('.resources-filter');
        if (action === 'add') {
            wrapper.addClass('loading');
        }

        if (action === 'remove') {
            wrapper.removeClass('loading');
        }
    }
//== end loader control ==//


//== start add check accordion ==//
    $('.resources-filter__accordion').each(function () {
        $(this).on("click", function () {
            if ($(this).hasClass('active')) {
                $(this).removeClass("active");
                $('.resources-filter__panel').css({ "maxHeight": 0 });
            } else {
                let current_panel = $('.resources-filter__panel');
                $(this).addClass("active");
                current_panel.css({ "maxHeight": current_panel.prop('scrollHeight') });
            }
        });
    });
//== start add check accordion ==//

//=== start ajax query ==//
    function doAjaxQuery(isCatQuery = false, is_first_iteration = false) {
        const search = getParameterByName('search');
        const category_param = getParameterByName('category');
        const data = {
            'action': 'get_sort_for_blog',
            'query': $('._blog-data').attr('data-param-posts'),
            'category': category_param,
        };
        const data_featured = {
            'action': 'get_sort_for_featered',
            'category': category_param,
        };
        if (is_first_iteration && search) {
            $(".resources-filter__input").val(search);
        }
        // if (is_first_iteration) {
        //     $(".resources-filter__accordion[data-term='" + category_parent_param + "']").addClass('active');
        //     let current_panel = $('.resources-filter__panel.panel__' + category_parent_param);
        //     var offTop = ($('#resources-content').offset().top + current_panel.prop('scrollHeight')) - 80;
        //     $(window).scrollTop(offTop);
        //     current_panel.css({ "maxHeight": current_panel.prop('scrollHeight') });
        // }
        if (is_first_iteration && category_param) {
            let category_arr = category_param.split(',');
            $.each(category_arr, function (key, value) {
                $('.resources-filter__panel input[data-slug="' + value + '"]').attr('checked', 'checked');
            });
            if (category_param === 'all') {
                setTimeout(() => {
                    $('.resources-filter__panel input').attr('checked', 'checked');
                    onChecked($('.resources-filter__panel input'))
                }, 1);
            }
        }
        if (search && search.length > 2) {
            data['search'] = search;
            data_featured['search'] = search;
        }
        loaderControl('add');
        $.ajax({
            url: '/wp-admin/admin-ajax.php',
            data: data,
            type: 'POST',
            success: function (data) {
                loaderControl('remove');
                if (data) {
                    this_page = 1;
                    $(".resources-content__wrapper").html(data);
                    const maxPages = $("._blog-data").attr('data-max-pages');
                    $('.btn-loadmore').removeClass('hidden');
                    // console.log(maxPages);
                    if (maxPages === 1 || !maxPages) {
                        $('.btn-loadmore').addClass('hidden');
                    }
                }
            },
        });
        $.ajax({
            url: '/wp-admin/admin-ajax.php',
            data: data_featured,
            type: 'POST',
            success: function (data) {
                if (data) {
                    $(".resources-featured-wrap").html(data);
                } else {
                    $(".resources-featured-wrap").html('');
                }
            },
        });
    }
//== end ajax query ==//

//== start on checked ==//
    $('.resources-filter__panel input').each(function () {
        $(this).on('change', function () {
            onChecked($(this));
        });
    });

    function onChecked(_this) {
        // const parent = _this.attr('data-parent');
        // $(`.resources-filter__panel input`).prop("checked", false);
        //== start uncheck 'all btn' ==//
        $('.resources-filter__panel input[data-slug="all"]').prop("checked", false);
        //== end uncheck 'all btn' ==//

        //== start check all checkboxes if check all btn ==//
        if (_this.attr('data-slug') === 'all') {
            $('.resources-filter__panel input').each(function () {
                $(this).prop("checked", true);
            });
        }
        //== end check all checkboxes if check all btn ==//

        //== start get slugs from url ==//
        let slugs = '';
        $('.resources-filter__panel input:checked').each(function () {
            let slug = $(this).attr('data-slug');
            slugs += slug + ',';
        });
        //== end get slugs from url ==//
        setSearchQueryBlog('category', slugs);
        // setSearchQueryBlog('parent-category', parent)
        doAjaxQuery(true);
    }
//== end on checked ==//

//== start load more ==//
    $('.btn-loadmore').on('click', function () {
        const search = getParameterByName('search');
        let _this = $(this);
        let _data = $('._blog-data');
        _this.html('<span class="fas fa-redo fa-spin"></span> Load...');

        let data = {
            'action': 'loadmore',
            'query': _data.attr('data-param-posts'),
            'page': this_page,
        };

        if (search && search.length > 2) {
            data['search'] = search;
        }

        $.ajax({
            url: '/wp-admin/admin-ajax.php',
            data: data,
            type: 'POST',
            success: function (data) {
                _this.html('<span class="fas fa-redo"></span> view more');
                if (data) {
                    // _data.remove()
                    $('.resources-content__clear').remove();
                    document.querySelector('.resources-content__wrapper').innerHTML += data;
                    this_page++;
                    console.log(this_page);
                    if (this_page === _this.attr('data-max-pages')) {
                        _this.addClass('hidden');
                    }
                } else {
                    _this.addClass('hidden');
                }

                const maxPages = $("._blog-data").attr('data-max-pages');
                if (maxPages === this_page) {
                    _this.addClass('hidden');
                }
            }
        });
    });
//== end load more ==//


    $('.resources-filter__input').on('input', function () {
        let _this = $(this);
        if (_this.val().length > 2) {
            setSearchQueryBlog('search', _this.val());
            doAjaxQuery();
        }
        if (_this.val().length === 0) {
            setSearchQueryBlog('search', _this.val());
            doAjaxQuery();
        }
    });
});



// WEBPACK FOOTER //
// ./src/js/custom/section-resources-overview.es6